module.exports = __webpack_public_path__ + "img/miaosha_bg_sy.c7efa8b8.png";